import CoreService from '@/core/core.service.js';
const debounce = require('lodash.debounce');
import regExpObj from '@/utils/regExp.js';

export default {
  components: {
  },
  data() {
    return {
      form: {
        companyName: '',
        socialCreditCode: '',
        legalPersonName: '',
        password: '',
        repassword: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入企业（经营主体）名称', trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { pattern: regExpObj.socialCreditCode, message: '请输入18位的统一社会信用代码', trigger: 'blur'}
        ],
        legalPersonName: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '设置新密码', trigger: 'blur' }
        ],
        repassword: [
          { required: true, message: '确认新密码', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
  },
  methods: {
    // 验证参数
    checkParams() {
      if (this.form.password !== this.form.repassword) {
        this.$errorMessage('两次密码输入不一致，请重新设置');
        return false;
      }
      return true;
    },
    submit: debounce(function () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.checkParams()) {
            console.log('【form】', this.form);
            this.$confirm('确定提交！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              CoreService.resetPassword(this.form).then(({ success }) => {
                if (success) {
                  this.$successMessage('密码重置成功！');
                  this.$router.push('/logon');
                }
              }).catch((error) => {
                this.$errorMessage(error.data);
              });
            });
          }
        }
      });
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    // 返回
    cancel () {
      this.$confirm('您确认要取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1);
      });
    }
  }
};
